(() => {
  /** @param {HTMLElement} group */
  function initGroup(group) {
    const buttons = /** @type {HTMLElement[]} */ (Array.from(group.querySelectorAll('[data-layout-button]')));
    const mediaImage = /** @type {HTMLImageElement | null} */ (group.querySelector('.madesa-projetos__layout-media img'));
    if (!buttons.length) return;

    /** @param {string} target */
    const activate = (target) => {
      buttons.forEach((button) => {
        const isActive = button.dataset.layoutButton === target;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      const activeButton = buttons.find((button) => button.classList.contains('is-active')) || null;

      if (!mediaImage || !activeButton) return;

      const nextSrc = activeButton.dataset.layoutImage || '';
      if (nextSrc) mediaImage.setAttribute('src', nextSrc);

      const nextAlt = activeButton.dataset.layoutAlt || '';
      if (nextAlt) mediaImage.setAttribute('alt', nextAlt);
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => activate(button.dataset.layoutButton || ''));
    });

    const initial = buttons.find((button) => button.classList.contains('is-active')) || buttons[0] || null;
    if (!initial) return;
    activate(initial.dataset.layoutButton || '');
  }

  function init() {
    const groups = Array.from(document.querySelectorAll('.madesa-projetos-page-layouts .madesa-projetos__section--layouts'));
    groups.forEach(initGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
